import React, { Component } from "react";
import Slider from "react-slick";
import "./SliderSection.scss";
import ProductCard from "../ProductCard/ProductCard";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return <div className={className} onClick={onClick} />;
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return <div className={className} onClick={onClick} />;
}

export default class SliderSection extends Component {
  render() {
    const settings = {
      dots: false,
      // infinite: true,
      speed: 500,
      slidesToShow: 5,
      slidesToScroll: 1,
      centerMode: true, 
      centerPadding: "70px", 
      pauseOnHover: true,
      responsive: [
        {
          breakpoint: 1367,
          settings: {
            centerPadding: "90px", 
            slidesToShow: 4,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            centerPadding: "70px",
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 600,
          settings: {
            centerPadding: "40px",
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 480,
          settings: {
            centerPadding: "60px",
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true, 
            speed: 2000,
            autoplaySpeed: 2000,
          }
        }
      ],
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
    }; 
    const { sliderList, title, bk } = this.props;
    console.log('sliderList', sliderList)
    return (
      <div className="slider-section-wrapper" style={{backgroundImage : "url(" + bk + ")"}}>
        <div className="container">
          <h4 className="section-title" style={{marginBottom : 10}}>{title}</h4>
          <div className="slider-section-content">
            <Slider {...settings}>
              {sliderList.map((card, idx) => (
                <div className="slide-holder" key={idx}>
                  <ProductCard card={card} />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    );
  }
}
